/* eslint-disable no-console */
import { clearAllSwatchbookData, getAllOfType } from '../swatchbook-utils';
import { login, logout, addSwatches } from './account-api';
import { openAccountModal, closeAccountModal } from './account-modal';
import { addCreateAccountCallbacks, resetCreateAccountForm } from './create-account';
import { validate } from '../../utils/form-validation-utils';

let initialLanuch = true;

const loginModalId = 'acct-login-modal';

const onLoginSubmit = (event, callbacks) => {
  event.preventDefault();
  const modalForm = document.querySelector('.acct-login-modal-form');
  const modalErrorMsg = modalForm.querySelector('.form-error-message');
  if (validate(modalForm)) {
    modalErrorMsg.classList.add('hide');
    let remember = false;
    if (document.querySelectorAll('#modalAcctRememberMe:checked').length === 1) {
      remember = true;
    }
    login(
      {
        username: document.getElementById('modalAcctUsername').value,
        password: document.getElementById('modalAcctPassword').value,
        rememberMe: remember,
      },
      {
        onSuccess: (data) => {
          // console.log(data);
          if (!data.success) {
            modalErrorMsg.classList.remove('hide');
          } else {
            window.isAuthenticated = true;
            window.userId = data['user-id'];
            checkLoginStatus(() => { /* eslint-disable-line no-use-before-define */
              if (callbacks) {
                if (callbacks.onLoginSuccess) {
                  callbacks.onLoginSuccess();
                }
              }
            });
            const modal = document.querySelector(`#${loginModalId}`);
            closeAccountModal(modal);
          }
        },
        onError: () => {
          if (!callbacks) {
            return;
          }
          if (callbacks.onLoginFail) {
            callbacks.onLoginFail();
          }
        },
      },
    );
  }
};

const onModalClose = (event, callback) => {
  if (callback) {
    callback();
  }
};

const onModalButtonClick = (event) => {
  const {
    grecaptchaApi,
    isAuthenticated,
    loginUrl,
    myAccountUrl,
  } = window;
  if (isAuthenticated) {
    return;
  }
  event.preventDefault();
  const score = grecaptchaApi.currentScore;
  if (grecaptchaApi.displayChallenge(score)) {
    window.location = loginUrl;
  } else {
    launchLoginModal({ // eslint-disable-line no-use-before-define
      type: '',
      callbacks: {
        onLoginSuccess: () => {
          window.location = myAccountUrl;
        },
        onLoginFail: () => {},
      },
    });
  }
};

const onLogoutButtonClick = (event) => {
  event.preventDefault();
  logout({
    onSuccess: () => {
      clearAllSwatchbookData();
      window.location = window.loginUrl;
    },
  });
};

const addLogoutEventHandlers = () => {
  const logoutBtns = document.querySelectorAll('a[href="/logout"], a[href="/logout/"]');
  if (logoutBtns) {
    [].map.call(logoutBtns, btn => btn.addEventListener('click', onLogoutButtonClick));
  }
};

const removeModalEventHandlers = () => {
  const modalBtns = document.querySelectorAll('.acct-login-modal-btn');
  // console.log('login.js, removeModalEventHandlers');
  // console.log(modalBtns);
  if (modalBtns) {
    [].map.call(modalBtns, btn => btn.removeEventListener('click', onModalButtonClick));
  }
};

const addModalEventHandlers = () => {
  const modalBtns = document.querySelectorAll('.acct-login-modal-btn');
  // console.log('login.js, addModalEventHandlers');
  // console.log(modalBtns);
  if (modalBtns) {
    [].map.call(modalBtns, btn => btn.addEventListener('click', onModalButtonClick));
  }
};

const checkLoginStatus = (callback) => {
  // console.log(`login.js, checkLoginStatus, isAuthenticated: ${window.isAuthenticated}`);
  const body = document.getElementsByTagName('body')[0];
  if (window.isAuthenticated) {
    body.classList.add('is-authenticated');
    removeModalEventHandlers();
    addLogoutEventHandlers();
    // Check to see if there are any swatches in localstorage
    const localStorageData = getAllOfType('swatch');
    if (localStorageData.length !== 0) {
      addSwatches(localStorageData, {
        onSuccess: () => {
          clearAllSwatchbookData();
          if (callback) {
            callback();
          }
        },
        onError: () => {
          if (callback) {
            callback();
          }
        },
      });
    } else {
      if (callback) { /* eslint-disable-line no-lonely-if */
        callback();
      }
    }
  } else {
    body.classList.remove('is-authenticated');
    addModalEventHandlers();
  }
};

const toggleCreateAccountForm = (isVisible) => {
  const modal = document.getElementById(loginModalId);
  if (isVisible) {
    modal.querySelector('.account-login-container').classList.add('hidden');
    // modal.querySelector('.login-side-column').classList.add('hidden');
    modal.querySelector('.create-account-container').classList.remove('hidden');
    // modal.querySelector('.create-account-side-column').classList.remove('hidden');
    if (modal.querySelectorAll('.login-message-wrapper').length !== 0) {
      modal.querySelector('.login-message-wrapper').classList.add('hidden');
    }
    modal.style.height = '600px';
  } else {
    modal.querySelector('.account-login-container').classList.remove('hidden');
    // modal.querySelector('.login-side-column').classList.remove('hidden');
    modal.querySelector('.create-account-container').classList.add('hidden');
    // modal.querySelector('.create-account-side-column').classList.add('hidden');
    modal.removeAttribute('style');
    if (modal.querySelectorAll('.login-message-wrapper').length !== 0) {
      modal.querySelector('.login-message-wrapper').classList.remove('hidden');
    }
  }
};

const launchLoginModal = (options) => {
  // Reset modal
  toggleCreateAccountForm();
  resetCreateAccountForm({
    form: document.querySelector('.modal-acct-create-form'),
  });
  const {
    type,
    callbacks,
  } = options;
  const modal = document.getElementById(loginModalId);
  if (type) {
    modal.classList.add('c-modal--loginCTA');
    modal.querySelector('.login-message-wrapper').classList.remove('hidden');
    let msg = '';
    switch (type) {
      case 'photo':
        msg = window.loginMessagePhoto;
        break;
      case 'location':
        msg = window.loginMessageDealer;
        break;
      case 'visualization':
        msg = window.loginMessageVisualization;
        break;
      default:
        break;
    }
    modal.querySelector('.login-message-wrapper p').innerHTML = msg;
  } else {
    modal.classList.remove('c-modal--loginCTA');
    modal.querySelector('.login-message-wrapper').classList.add('hidden');
    modal.querySelector('.login-message-wrapper p').innerHTML = '';
  }
  const overlay = document.querySelector('#modal-overlay');
  openAccountModal(modal);
  // Submit modal form
  const loginSubmitBtn = modal.querySelector('.acct-login-modal-form .o-form__submit');
  const modalCloseBtn = modal.querySelector('#close-btn');
  // const toggleCreateAccountBtn = modal.querySelector('.create-account-btn');
  // Only run once
  if (initialLanuch) {
    initialLanuch = false;
    loginSubmitBtn.addEventListener('click', (event) => {
      onLoginSubmit(event, callbacks);
    });
    modalCloseBtn.addEventListener('click', (event) => {
      event.stopPropagation();
      onModalClose(event, callbacks.onLoginFail);
    });
    if (overlay) {
      overlay.addEventListener('click', event => onModalClose(event, callbacks.onLoginFail));
    }
    // Toggle create account form
    if (type === 'visualization' || type === 'photo') {
      // Need to account for error message as well...
      [].map.call(document.querySelectorAll('.create-account-btn, .acct-login-modal-form .form-error-message a'), btn => btn.addEventListener('click', (event) => {
        event.preventDefault();
        addCreateAccountCallbacks({
          onLoginSuccess: () => {
            callbacks.onLoginSuccess();
            closeAccountModal(modal);
          },
          onLoginFail: () => {
            // console.log('onLoginFail');
            callbacks.onLoginFail();
          },
        });
        toggleCreateAccountForm(true);
      }));
    }
  }
};

const submitForm = (data, callbacks) => {
  login(data, callbacks);
};

const init = () => {
  checkLoginStatus();
};

export {
  checkLoginStatus,
  init,
  launchLoginModal,
  submitForm,
};
/* eslint-enable no-console */
